module.exports = __webpack_public_path__ + "assets/img/1051587020742_.pic_hd.ad8a1fba.jpg";